import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { RadialGaugeComponent } from "../../../components/client/radial-gauge/radial-gauge.component";
import { AssetStaticInfoComponent } from "../asset-static-info/asset-static-info.component";
import { BaseUrlConstantsService } from "../../services/base-url-constants.service";
import { BackendApiService } from "../../services/backend-api.service";
import { GaugeCardComponent } from "../gauge-card/gauge-card.component";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { DialogGraphscaleSettingsComponent } from "../../../components/client/dialog-graphscale-settings/dialog-graphscale-settings.component";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-thermals-tab",
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatButtonModule,
    AssetStaticInfoComponent,
    GaugeCardComponent,
  ],
  templateUrl: "./thermals-tab.component.html",
  styleUrl: "./thermals-tab.component.scss",
})
export class ThermalsTabComponent {
  @Input() type:string;
  public role: string;
  public serialNo: string = "EM1234590";
  public sensorData = BaseUrlConstantsService.transformerApi;

  //Winding Temperature Radial-Gauge.
  public tXformerWendingTemperatureData: any;

  //Oil Level Radial-Gauge.
  public eTxformerOilLevelData: any = [];

  //Oil Temperature Radial-Gauge.
  public eTxformerOilTemperatureData: any = [];

  gaugeShow: boolean = false;

  //Graph Scale Setting Dialog Box Data.
  public settings: any;
  public GraphScaleSettingData: any;

  constructor(
    private service: BackendApiService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getGaugeDataByID();
  }


  /* --------------------------------FUNCTIONS FOR TRANSFORMER THERMALS PAGE-------------------------------------------- */
  public async getGaugeDataByID() {
    //Radial-Gauge:: Oil Temperature Data.
    this.service
      .getDataWithQuery(this.sensorData + "/oil-temperature/" + this.serialNo)
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.eTxformerOilTemperatureData = [];
          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let gaugeData = response.sensor;
              let needleValueRes;

              if (gaugeData[0].symbol === "C") {
                needleValueRes = JSON.parse(gaugeData[0].value);
              }

              let centerLab =
                JSON.parse(gaugeData[0].value) < 0
                  ? "N/A"
                  : JSON.parse(gaugeData[0].value);
              let arc_colors =
                gaugeData[0].needle === true
                  ? gaugeData[0].arcColors
                  : ["transparent", "transparent", "transparent"];
              let range_label =
                gaugeData[0].needle === true ? gaugeData[0].rangelabel : [];
              let arc_Delimiters =
                gaugeData[0].needle === true ? gaugeData[0].arcDelimiters : [];
              let bottomLab = "N/A";

              bottomLab =
                JSON.parse(gaugeData[0].value) <= 0
                  ? "N/A"
                  : gaugeData[0].symbol === "C"
                  ? JSON.parse(gaugeData[0].value) + " °" + gaugeData[0].icon
                  : JSON.parse(gaugeData[0].value) + " " + gaugeData[0].icon;

              const OilTempAccelerationData = {
                // value:value,
                needleValue: needleValueRes,
                centralLabel: centerLab,
                outerNeedle: false,
                canvasWidth: 150,
                name: gaugeData[0].name,
                key: gaugeData[0].key,
                bottomLabel: bottomLab,
                hasneedle: true,
                options: {
                  hasNeedle: gaugeData[0].needle,
                  needleColor: "black",
                  needleUpdateSpeed: "",
                  arcColors: arc_colors,
                  //arcLabels: [],
                  arcLabels: [] as string[],
                  arcDelimiters: gaugeData[0].arcDelimiters,
                  rangeLabel: range_label,
                  needleStartValue: 0,
                },
              };

              if (
                arc_Delimiters[0] < 100 &&
                arc_Delimiters[0] > 0 &&
                arc_Delimiters[1] > 0 &&
                arc_Delimiters[0] < arc_Delimiters[1] &&
                arc_Delimiters[1] < 100
              ) {
                let max = range_label[1] != null ? range_label[1] : 0;

                OilTempAccelerationData.options.arcLabels[0] =
                  sensorRes.body.rangeLabels.green;
                OilTempAccelerationData.options.arcLabels[1] =
                  sensorRes.body.rangeLabels.yellow;
                let velocityG = sensorRes.body.rangeLabels.green;
                let velocityY = sensorRes.body.rangeLabels.yellow;
                let velocityR = max;
                OilTempAccelerationData.options.arcColors[0] = "#72FF13";
                OilTempAccelerationData.options.arcColors[1] = "#FAA700";
                OilTempAccelerationData.options.arcColors[2] = "#ff2a1b";

                if (
                  OilTempAccelerationData.centralLabel <=
                  OilTempAccelerationData.options.arcLabels[0]
                ) {
                  // accelerationData.options.centralLabel=
                  OilTempAccelerationData.options.needleColor = "#72FF13";
                } else if (
                  OilTempAccelerationData.centralLabel >
                    OilTempAccelerationData.options.arcLabels[0] &&
                  OilTempAccelerationData.centralLabel <=
                    OilTempAccelerationData.options.arcLabels[1]
                ) {
                  OilTempAccelerationData.options.needleColor = "#FAA700";
                } else {
                  OilTempAccelerationData.options.needleColor = "#ff2a1b";
                }
                OilTempAccelerationData.centralLabel =
                  OilTempAccelerationData.centralLabel;

                this.eTxformerOilTemperatureData.push(OilTempAccelerationData);
                this.gaugeShow = true;
              }
            }
          }
        }
      });
  }
  openExformerGraphSettingsDialog(metric_type: string, asset_id: number): void {
    this.getExformerGraphScaleSettingsDataByID(metric_type, asset_id);

    this.getExformerGraphScaleSettingsDataByID(metric_type, asset_id)
      .then((data: any) => {
        //set data into GraphScaleSettingData variable.
        this.GraphScaleSettingData = [];
        let response = data.body;
        this.GraphScaleSettingData.push({
          metric_type: metric_type,
          asset_id: asset_id,
          green: response.threshold_1,
          yellow: response.threshold_2,
          red: response.threshold_3,
          max_value: response.max_value,
          min_value: response.base_value,
        });

        //Open Dialog Box.
        const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
          width: "800px",
          data: this.GraphScaleSettingData[0], // Pass settings data to dialog
        });

        //Closed Dialog box
        dialogRef.afterClosed().subscribe((updatedSettings) => {
          if (updatedSettings) {
            this.saveSettings(updatedSettings);
            this.ngOnInit();

            // Show toast message
            this._snackBar.open(
              "Settings has been saved successfully.",
              "Dismiss",
              {
                duration: 2000,
                horizontalPosition: "center",
                verticalPosition: "top" as MatSnackBarVerticalPosition, // Explicitly specify the type
                panelClass: ["custom-snackbar"],
              }
            );
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle error here
      });
  }
  public async getExformerGraphScaleSettingsDataByID(
    metric_type: string,
    asset_id: number
  ): Promise<any> {
    try {
      const sensorRes = await this.service
        .getDataWithQuery(
          `${this.sensorData}/etxformer-graph-scale-settings/${metric_type}/${asset_id}`
        )
        .then((res) => {
          return res;
        });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;

      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error("No data found in sensor response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  saveSettings(updatedSettings: any): void {
    // Implement saving logic using DataService
    // Example:
    this.service
      .saveSettings(
        this.sensorData + "/etxformer-graph-scale-settings-save",
        updatedSettings
      )
      .then(
        () => {
          console.log("Settings saved successfully");
        },
        (error) => {
          console.error("Error saving settings:", error);
        }
      );
  }
  /* --------------------------------FUNCTIONS FOR TRANSFORMER THERMALS PAGE ENDS-------------------------------------------- */

}
